﻿<script setup lang="ts">
    import { reactive, onMounted } from 'vue';

    const props = defineProps<{
        countdownTo: string;
    }>();

    const state = reactive<{
        showTimer: boolean;
        days: number | null;
        hours: number | null;
        minutes: number | null;
        seconds: number | null;
    }>({
        showTimer: false,
        days: null,
        hours: null,
        minutes: null,
        seconds: null,
    });

    onMounted(async () => {
        startTimer(props.countdownTo);
    });

    const startTimer = (date: string) => {
        date = date.replace('Z', '');

        // Set the date we're counting down to
        const countDownDate = new Date(date).getTime();

        // Update the count down every 1 second
        const interval = setInterval(() => {
            update(countDownDate, interval);
        }, 1000);

        update(countDownDate, interval);
    };

    const update = (countDownDate: number, interval: ReturnType<typeof setInterval>) => {
        const dateUtc = new Date().toUTCString();

        // Get todays date and time
        const now = new Date(dateUtc).getTime();

        // Find the distance between now an the count down date
        const distance = countDownDate - now;

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Display the result
        if (days >= 0) state.days = days;
        if (hours >= 0) state.hours = hours;
        if (minutes >= 0) state.minutes = minutes;
        if (seconds >= 0) state.seconds = seconds;

        // If the count down is finished
        if (distance < 0) {
            clearInterval(interval);
        }

        state.showTimer = distance >= 0;
    };
</script>

<script lang="ts"></script>

<template>
    <div class="text-center" v-show="state.showTimer">
        <!--
        <p class="text-lg m-sm-t" data-bind="text:header"></p>
        -->

        <div class="countdown-clock">
            <div>
                <span class="count">{{ state.days }}</span>
                <small>{{ $Resources.SendingCountdownDays }}</small>
            </div>
            <div>
                <span class="count">{{ state.hours }}</span>
                <small>{{ $Resources.SendingCountdownHours }}</small>
            </div>
            <div>
                <span class="count">{{ state.minutes }}</span>
                <small>{{ $Resources.SendingCountdownMinutes }}</small>
            </div>
            <div>
                <span class="count">{{ state.seconds }}</span>
                <small>{{ $Resources.SendingCountdownSeconds }}</small>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less"></style>

<style lang="less"></style>
